// extracted by mini-css-extract-plugin
export default {"sheet":"DocumentEditModal_sheet__RAvrR","icon":"DocumentEditModal_icon__n3Ad6","switch":"DocumentEditModal_switch__z+d1w"};